/**
 * Determine if a given location origin is a production environment URL
 * @param {string} locationOrigin - URL origin to check
 * @returns {boolean} True if production environment, false otherwise
 */
export const isProductionEnvironmentUrl = (locationOrigin = '') => {
  const nonProdEnvironmentPattern = /(?:qaprod-|qa-|dev\.|ast-|staging-|localhost)/ig;

  locationOrigin = locationOrigin || window?.location?.origin || '';

  // if match for `nonProdEnvironmentPattern` is not found, we assume locationOrigin is a production url
  return !locationOrigin?.match?.(nonProdEnvironmentPattern);
};

/**
 * Construct environment-specific translation key
 * @param {string} baseKey - Base translation key (e.g., 'externalLogoutUrl')
 * @param {string} locationOrigin - URL origin to check environment
 * @returns {string} Environment-specific translation key (e.g., 'externalLogoutUrl_QA')
 */
export const getEnvironmentSpecificTranslationKey = (baseKey, locationOrigin = '') => {
  const envSuffix = getEnvironmentSuffix(locationOrigin);
  return `${baseKey}_${envSuffix}`;
};

/**
 * Get environment suffix based on URL origin
 * @param {string} locationOrigin - URL origin to check
 * @returns {string} Environment suffix (e.g., 'Prod', 'QA', 'Dev', 'AST', 'Staging', 'Localhost', 'QAProd')
 */
export const getEnvironmentSuffix = (locationOrigin = '') => {
  locationOrigin = locationOrigin || window?.location?.origin || '';

  if (locationOrigin.match(/qaprod-/i)) {
    return 'QAProd';
  } else if (locationOrigin.match(/qa-/i)) {
    return 'QA';
  } else if (locationOrigin.match(/dev\./i)) {
    return 'Dev';
  } else if (locationOrigin.match(/ast-/i)) {
    return 'AST';
  } else if (locationOrigin.match(/staging-/i)) {
    return 'Staging';
  } else if (locationOrigin.match(/localhost/i)) {
    return 'Localhost';
  }

  // Default to production
  return 'Prod';
};
